import {API} from "./config";
import {convertKeysToCamelCase, objectToQueryString} from "../utils";
import {axiosClientNoti, handleRequest} from "./axiosClient";


export const getListNoti = async (params) => {
  const queryString = objectToQueryString(params);
  const url = `${API.noti.getListNoti}?${queryString}`;
  const response = await handleRequest(axiosClientNoti.get(url));
  const newResponse = {
    items: convertKeysToCamelCase(response?.data?.data?.items),
    success: response?.success,
    status: response?.status,
    code: response?.data?.code,
    total: response?.data?.data?.total,
    size: response?.data?.data?.size,
    page: response?.data?.data?.page,
  }
  return {...newResponse};
};
export const getCountNoti = async (params) => {
  const queryString = objectToQueryString(params);
  const url = `${API.noti.getCountNoti}?${queryString}`;
  const response = await handleRequest(axiosClientNoti.get(url));
  const newResponse = {
    total: convertKeysToCamelCase(response?.data?.data?.total),
    success: response?.success,
  }
  return {...newResponse};
};
export const readMarkNotiById = async (notiId) => {
  const url = `${API.noti.readMarkNotiById.replace("{id}", notiId)}`;
  const response = await handleRequest(axiosClientNoti.post(url));
  const newResponse = {
    success: response?.success,
    code: response?.data?.code,
  }
  return {...newResponse};
};
export const deleteNoti = async (notiId) => {
  const url = `${API.noti.deleteNoti.replace("{id}", notiId)}`;
  const response = await handleRequest(axiosClientNoti.delete(url));
  const newResponse = {
    success: response?.success,
    code: response?.data?.code,
  }
  return {...newResponse};
};
export const readMarkNotiAll = async () => {
  const url = `${API.noti.readMarkNotiAll}`;
  const response = await handleRequest(axiosClientNoti.post(url));
  const newResponse = {
    success: response?.success,
    code: response?.data?.code,
  }
  return {...newResponse};
};
